module.exports = __webpack_public_path__ + "static/media/pricingV1Full.e0fd7df4.mp4";